import { CircleDot, CreditCard, GitBranch, Hourglass, Mail, TriangleAlert, UserSearch, } from 'lucide-react';
import { nodeSpec, summaryRu } from './graph/index.js';
const tokens = (category) => ({
    bg: `--color-pipeline-${category}-bg`,
    fg: `--color-pipeline-${category}-fg`,
});
export const CATEGORY_VISUALS = {
    check: { icon: GitBranch, labelRu: 'Проверка', ...tokens('check') },
    mail: { icon: Mail, labelRu: 'Письмо', ...tokens('mail') },
    wait: { icon: Hourglass, labelRu: 'Ждём ответ', ...tokens('wait') },
    identity: { icon: UserSearch, labelRu: 'Поиск аккаунта', ...tokens('identity') },
    subscription: { icon: CreditCard, labelRu: 'Подписка', ...tokens('subscription') },
    status: { icon: CircleDot, labelRu: 'Статус диалога', ...tokens('status') },
    danger: { icon: TriangleAlert, labelRu: 'Необратимо', ...tokens('danger') },
};
export const categoryVisual = (category) => CATEGORY_VISUALS[category];
/** Visual of a node, by its type's category. */
export const nodeVisual = (node) => categoryVisual(nodeSpec(node).category);
/**
 * «N. Название шага» — a step as a routing target («Куда дальше», menus). Steps
 * carry no author-given name in the schema, so the name is the type label plus
 * the parameter summary when there is one («9. Отправить шаблон письма —
 * Шаблон «Refund» · через 3 дня»).
 */
export const stepOptionLabelRu = (node, stepNumber, ctx) => {
    const label = nodeSpec(node).labelRu;
    const summary = ctx ? summaryRu(node, ctx) : null;
    const name = summary ? `${label} — ${summary}` : label;
    return stepNumber === undefined ? name : `${stepNumber}. ${name}`;
};
//# sourceMappingURL=visual.js.map